import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle, FaArrowLeft } from 'react-icons/fa';

const ErrorMessage = ({ message }) => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-700 flex items-center justify-center p-4">
      <motion.div 
        className="bg-black bg-opacity-60 backdrop-filter backdrop-blur-lg p-6 rounded-xl max-w-md w-full"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex items-center justify-center mb-4">
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: [0.8, 1.2, 0.8] }}
            transition={{ 
              repeat: Infinity,
              duration: 2,
              ease: "easeInOut" 
            }}
            className="text-blue-500 text-5xl"
          >
            <FaExclamationTriangle />
          </motion.div>
        </div>
        
        <h2 className="text-xl text-white font-bold text-center mb-4">Error</h2>
        <p className="text-blue-300 text-center mb-6">{message}</p>
        
        <div className="flex justify-center">
          <motion.button
            onClick={() => navigate('/')}
            className="py-2 px-6 bg-blue-600 text-white rounded-lg hover:bg-blue-500 transition duration-300 flex items-center gap-2"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaArrowLeft />
            Back to Home
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default ErrorMessage;